import { inject } from "@angular/core";
import { ProjectsQuery, UserSettingsQuery } from "@timeghost/web-api";

export const useUserFind = () => {
	const userSettingsQuery = inject(UserSettingsQuery);
	const user = userSettingsQuery.getValue();
	return (userId: string) => user.workspace.users.find((u) => u.id === userId);
};
export const useProjectFind = () => {
	const projectsQuery = inject(ProjectsQuery);
	return (projectId: string) => projectsQuery.getEntity(projectId);
};
export const useUserSettings = () => {
	const userSettingsQuery = inject(UserSettingsQuery);
	return userSettingsQuery.getValue();
};
export const useWorkspace = () => {
	const userSettingsQuery = inject(UserSettingsQuery);
	return userSettingsQuery.getValue().workspace;
};
